import {DocumentDto, FileDto} from '|api/document';
import {DEFAULT_SEARCHABLE_ENTITY_TYPES_FILTER, DocumentSearchService} from '|shared';
import {FilterOperator, IczTableDataSource} from '@icz/angular-table';

export class SharedFolderFilterDefinitionSearchDatasource extends IczTableDataSource<DocumentDto | FileDto> {
  constructor(
    documentSearchService: DocumentSearchService,
  ) {
    super(
      searchParams => {
        searchParams.filter.push(
          {
            fieldName: 'issdId',
            value: null,
            operator: FilterOperator.empty
          },
        );

        return documentSearchService.globalSearch(searchParams);
      },
    );

    this.additionalSearchParams = DEFAULT_SEARCHABLE_ENTITY_TYPES_FILTER;
  }
}
